<script setup lang="ts">
import { SidepanelNavigationItem } from '@/models/SidepanelNavigationItem';

withDefaults(defineProps<{
	navigation?: SidepanelNavigationItem[];
}>(), {
	navigation: () => [],
});
</script>

<template>
	<div>
		<RouterLink
			v-for="item in navigation"
			:key="item.name"
			v-slot="{ isExactActive }"
			:to="item.to"
			class="inline-block mr-6 hover:underline underline-offset-2"
		>
			<span :class="{ 'text-secondary underline': isExactActive }">
				{{ item.name }}
			</span>
		</RouterLink>
	</div>
</template>
